import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, ease, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineVariants = { hidden: { y: "105%" }, show: { y: "0%" } };

export const MaskLine = ({ children, delay = 0, className = "", onLoad = false }) => {
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0 } };
  return (
    <motion.span className="block overflow-hidden pb-[0.06em] pt-[0.16em] -mt-[0.16em]" initial="hidden" {...trigger}>
      <motion.span className={`block ${className}`} variants={lineVariants} transition={{ duration: 1.1, ease, delay }}>
        {children}
      </motion.span>
    </motion.span>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.3em] text-[var(--signal)] ${className}`}>{children}</p>
);
